import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import drEasyApi from '../Api/Customapi';

export const useExpenses = () => {
    const queryClient = useQueryClient();

    // Get all expenses with pagination
    const useGetExpenses = (filters) => {
        return useQuery({
            queryKey: ['expenses', filters],
            queryFn: async () => {
                const params = new URLSearchParams();
                
                if (filters.PageNumber) params.append('PageNumber', filters.PageNumber);
                if (filters.PageSize) params.append('PageSize', filters.PageSize);

                const { data } = await drEasyApi.get(`/api/Expenses/GetAll?${params.toString()}`);
                return data;
            },
            onError: (err) => {
                if (err.response?.status === 403) {
                    window.location.href = "/sub";
                } else {
                    message.error('Failed to fetch expenses');
                }
            }
        });
    };

    // Create expense
    const useCreateExpense = () => {
        return useMutation({
            mutationFn: async (expenseData) => {
                const { data } = await drEasyApi.post('/api/Expenses/Create', expenseData);
                return data;
            },
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ['expenses'] });
                message.success('Expense created successfully');
            },
            onError: (err) => {
                if (err?.response?.status === 400) {
                    const errorMessage = err?.response?.data?.message || 'Please check your input and try again';
                    message.error(errorMessage);
                } else {
                    message.error('Failed to create expense');
                }
            }
        });
    };

    // Update expense
    const useUpdateExpense = () => {
        return useMutation({
            mutationFn: async (expenseData) => {
                const { data } = await drEasyApi.put('/api/Expenses/Edit', expenseData);
                return data;
            },
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ['expenses'] });
                message.success('Expense updated successfully');
            },
            onError: (err) => {
                if (err?.response?.status === 400) {
                    const errorMessage = err?.response?.data?.message || 'Please check your input and try again';
                    message.error(errorMessage);
                } else {
                    message.error('Failed to update expense');
                }
            }
        });
    };

    // Delete expense
    const useDeleteExpense = () => {
        return useMutation({
            mutationFn: async (id) => {
                const { data } = await drEasyApi.delete('/api/Expenses/Delete', {
                    params: { Id: id }
                });
                return data;
            },
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ['expenses'] });
                message.success('Expense deleted successfully');
            },
            onError: () => {
                message.error('Failed to delete expense');
            }
        });
    };

    return {
        useGetExpenses,
        useCreateExpense,
        useUpdateExpense,
        useDeleteExpense,
    };
};